import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type Props = {
  /**
   * Any value that changes when user "switches pages".
   * We refetch on mount + whenever this key changes.
   */
  watchKey: string;
};

export function SystemErrorAlert({ watchKey }: Props) {
  const [failureCount, setFailureCount] = useState<number>(0);
  const whatsappUrl = "https://api.whatsapp.com/send?phone=60123109663";

  useEffect(() => {
    const controller = new AbortController();

    async function run() {
      try {
        const resp = await fetch("/v1/api/general-feature/failure-logs/count/", {
          method: "GET",
          signal: controller.signal,
        });
        if (!resp.ok) return;

        const data = (await resp.json()) as unknown;
        const count = Number((data as any)?.count ?? 0);
        if (!Number.isFinite(count) || count < 0) return;
        setFailureCount(count);
      } catch {
        // Silent: we only show the banner when the backend confirms failures exist.
      }
    }

    void run();

    return () => controller.abort();
  }, [watchKey]);

  if (failureCount <= 0) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <div>
        <AlertTitle className="text-destructive">System Error Detected</AlertTitle>
        <AlertDescription className="text-destructive">
          Error detected at the backend. Please contact your developer to check the error. Please contact at{" "}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2 hover:opacity-90"
          >
            Here
          </a>
          .
        </AlertDescription>
      </div>
    </Alert>
  );
}

